import * as React from 'react';
import "./GiftOrderDetails.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { useState } from 'react';
import moment from 'moment';
import { updateGiftOrder } from '../../shared/api/user';
import { useParams } from "react-router-dom";
import { getGiftOrderById } from '../../shared/api/user';
import { useEffect } from 'react';
import ClearIcon from '@mui/icons-material/Clear';

export default function BasicTable() {
    const [orders, setOrders] = useState([]);
    const [dishes, setDishes] = useState([]);
    const [addons, setAddons] = useState([]);
    const [gifts, setGifts] = useState([]);
    const { id } = useParams();

    const getCurrencySymbol = (orderFrom) => {
        if (orderFrom === "GB") return "£";
        if (orderFrom === "US") return "$";
        return "Rs. ";
    };

    const init = async () => {
        let rows = await getGiftOrderById(id);
        setOrders(rows.data.giftOrder);
        let dishes = [];
        let addons = [];
        let gifts = [];

        rows.data.giftOrder.orderItems.forEach((e => {
            e.gift.quantity = e.quantity;
            e.gift.size = e.size;
            gifts.push(e.gift);
        }))
        {console.log('gifts',gifts)}
        setGifts(gifts)
        if (rows.data.giftOrder.foodOrderId) {
            rows.data.giftOrder.foodOrderId.orderItems.forEach((e => {
                e.dish.quantity = e.quantity;
                dishes.push(e.dish);
            }))
            setDishes(dishes)
            rows.data.giftOrder.foodOrderId.orderItems.forEach((e => {
                e.addons.forEach((a => {
                    e.dish.addons.forEach((addon => {
                        if (a.addon === addon._id) {
                            addon.quantity = a.quantity;
                            addons.push(addon);
                        }
                    }))
                }))
            }))
            setAddons(addons)
        }
    }

    useEffect(() => {
        init();
    }, []);

    async function updateOrderDetails(id) {
        let status = await updateGiftOrder(id, { orderStatus: 'CANCELLED' });
        init();
    }

    return (
        <div>
            {orders.orderStatus === 'PENDING' && <Button onClick={() => updateOrderDetails(id)} sx={{ mb: 2, fontWeight: '600' }} variant="outlined" style={{ float: "right" }} startIcon={<ClearIcon />}>
                Cancel Order
            </Button>}
            <div className='content-details-div'>
                <div className='items-details'>
                    <TableContainer className='table-container table-width' component={Paper}>
                        <Table sx={{ minWidth: 450 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='table-call-row'>Gift Name</TableCell>
                                    <TableCell className='table-call-row' align="right">Quantity</TableCell>
                                    <TableCell className='table-call-row' align="right">Description</TableCell>
                                    <TableCell className='table-call-row' align="right">Gift Price</TableCell>
                                    <TableCell className='table-call-row' align="right">Size</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {gifts.map((row) => (                                    
                                    <TableRow
                                        key={orders._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell className='table-call-row-data' component="th" scope="row">{row.name.substring(0, 25)}...</TableCell>
                                        {row.offers && <TableCell align="right">{row.quantity * 2}</TableCell>}
                                        {!row.offers && <TableCell align="right">{row.quantity}</TableCell>}
                                        <TableCell className='table-call-row-data' align="right">{row.description.substring(0, 25)}...</TableCell>
                                        <TableCell className='table-call-row-data' align="right">Rs. {row.price}</TableCell>
                                        <TableCell className='table-call-row-data' align="right">{row.size}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {orders.foodOrderId && <TableContainer className='table-container table-width' sx={{ mt: 3 }} component={Paper}>
                        <Table sx={{ minWidth: 450 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='table-call-row'>Dish Name</TableCell>
                                    <TableCell className='table-call-row' align="right">Quantity</TableCell>
                                    <TableCell className='table-call-row' align="right">Description</TableCell>
                                    <TableCell className='table-call-row' align="right">Dish Price</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dishes.map((row) => (
                                    <TableRow
                                        key={orders._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell className='table-call-row-data' component="th" scope="row">{row.dishName.substring(0, 25)}...</TableCell>
                                        {row.offers && <TableCell align="right">{row.quantity * 2}</TableCell>}
                                        {!row.offers && <TableCell align="right">{row.quantity}</TableCell>}
                                        <TableCell className='table-call-row-data' align="right">{row.description.substring(0, 25)}...</TableCell>
                                        <TableCell className='table-call-row-data' align="right">Rs. {row.price}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>}
                    {orders.foodOrderId && <TableContainer className='table-container' sx={{ mt: 3 }} component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead className='table-head'>
                                <TableRow>
                                    <TableCell className='table-call-row'>Addon Name</TableCell>
                                    <TableCell className='table-call-row' align="right">Quantity</TableCell>
                                    <TableCell className='table-call-row' align="right">Description</TableCell>
                                    <TableCell className='table-call-row' align="right">Addon Price</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {addons.map((row) => (
                                    <TableRow
                                        key={orders._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell className='table-call-row-data' component="th" scope="row">{row.addonName}</TableCell>
                                        <TableCell className='table-call-row-data' align="right">{row.quantity}</TableCell>
                                        <TableCell className='table-call-row-data' align="right">{orders.description}</TableCell>
                                        <TableCell className='table-call-row-data' align="right">Rs. {row.addonPrice}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>}
                </div>
                <div>
                    <div className='pricing'>
                        <div className='title-details'>Order Details</div>
                        <div className='total-flex'>
                            <div><b>Customer Name</b></div>
                            <div>{orders.user?.firstName} {orders.user?.lastName}</div>
                        </div>
                        <div className='total-flex'>
                            <div><b>Order Time</b></div>
                            <div>{moment(orders.createdAt).format('MMMM Do YYYY, h:mm a')}</div>
                        </div>
                        <div className='total-flex'>
                            <div><b>Order Status</b></div>
                            <div>{orders.orderStatus}</div>
                        </div>
                        <div className='total-flex'>
                            <div><b>Order Type</b></div>
                            <div>{orders.orderType}</div>
                        </div>
                        <div className='total-flex'>
                            <div><b>Order From Country</b></div>
                            <div>{orders.orderFrom}</div>
                        </div>
                                            <div className='total-flex'>
                        <div><b>Receiver Phone No.</b></div>
                        <div>{orders.receiverPhone}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Receiver Address</b></div>
                        <div>{orders.receiverAddress}</div>
                    </div>
                        <div className='total-flex'>
                            <div><b>Payment Status</b></div>
                            <div>{orders.paymentStatus}</div>
                        </div>
                        <div className='total-flex'>
                            <div><b>Sub Total</b></div>
                            <div> {getCurrencySymbol(orders.orderFrom)} {orders.subTotal}</div>
                        </div>
                        <div className='total-flex'>
                            <div><b>Service Fee & Other Charges</b></div>
                            <div>{getCurrencySymbol(orders.orderFrom)} {(orders.serviceFee + orders.taxAmount)?.toFixed(2)}</div>
                        </div>
                        <div className='total-flex'>
                            <div><b>Total</b></div>
                            {orders.foodOrderId && <div><b>{getCurrencySymbol(orders.orderFrom)} {(orders?.total + orders.foodOrderId.serviceFee)?.toFixed(2)}</b></div>}
                            {!orders.foodOrderId && <div><b>{getCurrencySymbol(orders.orderFrom)} {(orders?.total)?.toFixed(2)}</b></div>}
                        </div>
                        <div className='total-flex'>
                            <div><b>Sender Phone No.</b></div>        
                                 <div>{orders.user?.phoneNumber}</div>
                        </div>
                        <div className='total-flex'>
                            <div><b>Sender Email</b></div>        
                                 <div>{orders.user?.email}</div>
                        </div>
                        <div className='total-flex'>
                            <div><b>Order Notes</b></div>
                            <div>{orders.notes}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}